var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.254 17.9841V9.34921C19.254 9.1915 19.2172 9.03595 19.1467 8.89489C19.0762 8.75384 18.9738 8.63113 18.8476 8.53651L11.7365 3.20317C11.5607 3.07129 11.3468 3 11.127 3C10.9072 3 10.6933 3.07129 10.5175 3.20317L3.40635 8.53651C3.28018 8.63113 3.17778 8.75384 3.10725 8.89489C3.03672 9.03595 3 9.1915 3 9.34921V17.9841C3 18.2536 3.10703 18.5119 3.29754 18.7025C3.48806 18.893 3.74645 19 4.01587 19H8.07937C8.34879 19 8.60718 18.893 8.7977 18.7025C8.98821 18.5119 9.09524 18.2536 9.09524 17.9841V14.9365C9.09524 14.6671 9.20227 14.4087 9.39278 14.2182C9.58329 14.0277 9.84169 13.9206 10.1111 13.9206H12.1429C12.4123 13.9206 12.6707 14.0277 12.8612 14.2182C13.0517 14.4087 13.1587 14.6671 13.1587 14.9365V17.9841C13.1587 18.2536 13.2658 18.5119 13.4563 18.7025C13.6468 18.893 13.9052 19 14.1746 19H18.2381C18.5075 19 18.7659 18.893 18.9564 18.7025C19.1469 18.5119 19.254 18.2536 19.254 17.9841Z",
    stroke: "#0BB0D1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.ee2941c599c05b792ea8107b68b47a6b.svg";
export { ForwardRef as ReactComponent };